module.exports = __webpack_public_path__ + "static/yellowpages-icon-4acc251dfc06a23ead3ae869b436e562.png";